module.exports = __webpack_public_path__ + "img/FAMSTecmo2.5f8ea8fa.png";